import gql from 'graphql-tag'

export const getArticles = gql`
  query DooerComGetAcademyArticles($filter: String) {
    academy {
      articles(filter: $filter) {
        totalCount
        edges {
          node {
            id
            slug
            category {
              id
              slug
              parentCategory {
                id
                slug
                parentCategory {
                  id
                  slug
                  parentCategory {
                    id
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
